export default __webpack_public_path__ + "static/media/5.39200467.jpg";